<template>
  <div id="app">
    <Header></Header>
    <Body></Body>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Body from './components/Body.vue'
export default {
  name: 'app',
  components: {
    Header,
    Body
  }
}
</script>

<style>
  html, body {
    height: 100%;
  }
  html, body, * {
    font-family: 'Merriweather', serif;
  }
  .primary {
    background-color: #2196f3 !important;
    color: black !important;
  }
  .primary-light {
    background-color: #6ec6ff !important;
    color: black !important;
  }
  .primary-dark {
    background-color: #006db3 !important;
    color: white !important;
  }
  
  .secondary {
    background-color: #00e676 !important;
    color: black !important;
  }
  .secondary-light {
    background-color: #66ffa6 !important;
    color: black !important;
  }
  .secondary-dark {
    background-color: #00b248 !important;
    color: white !important;
  }
</style>
